import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../ui/Button";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Products", path: "/products" },
    { name: "Biogas Plant", path: "/biogas-plant" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <>
      {/* Header Container */}
      <header className="bg-[#1c233a] rounded-[50px] mx-[25px] 2xl:mx-[50px] mt-[25px] 2xl:mt-[50px] p-[14px] w-[95%] mx-auto relative z-40">
        <div className="ml-[14px]">
          <div className="flex flex-row justify-between items-center w-full gap-4 lg:gap-0">
            {/* --- Logo Section --- */}
            <div className="flex justify-start items-center gap-[10px] w-full lg:w-[16%]">
              <Link to="/" className="relative block">
                <img
                  src="/images/BottomLogo.webp"
                  alt="Company LogoCircle"
                  className="max-w-[50px] max-h-[50px] md:max-w-[50px] md:max-h-[50px] 2xl:w-auto 2xl:h-auto animate-spin-slow"
                />
                <div className="absolute top-0 w-[50px] h-[50px]">
                  <img
                    src="/images/TopLogo.webp"
                    alt="Company LogoCircle"
                    className="w-[50px] md:w-[50px] h-[50px] md:h-[50px] 2xl:w-auto 2xl:h-auto"
                  />
                </div>
              </Link>
              <Link to="/" className="relative block">
                <div className="flex justify-center items-center">
                  <img
                    src="/images/logoText.png"
                    alt="Company Logo"
                    className="max-w-[150px]  md:max-w-auto 2xl:h-auto"
                  />
                </div>
              </Link>
            </div>

            {/* --- Hamburger Menu Button (Mobile Trigger) --- */}
            <button
              className="block lg:hidden p-3 text-white focus:outline-none z-50"
              aria-label="Open menu"
              onClick={() => setMenuOpen(true)}
            >
              <svg
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M3 12h18M3 6h18M3 18h18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>

            {/* --- Desktop Navigation --- */}
            <nav className="hidden lg:flex flex-row gap-[25px] sm:gap-[35px] 2xl:gap-[50px] justify-center items-center">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-[16px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] hover:opacity-75 transition-opacity"
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            {/* --- CTA Button (Desktop) --- */}
            <div className="hidden lg:block">
              <Link to="/contact">
                <Button
                  text="Learn More"
                  text_font_size="16"
                  text_font_family="Sora"
                  text_font_weight="700"
                  text_line_height="20px"
                  text_text_align="center"
                  text_color="#ffffff"
                  fill_background_color="#7abf6b"
                  border_border_radius="30px"
                  border_border="none"
                  padding="6px 15px"
                  className="text-[16px] sm:text-[20px] 2xl:text-[24px] leading-[20px] sm:leading-[25px] 2xl:leading-[31px] py-[6px] px-[15px] sm:py-[9px] sm:px-[22px] 2xl:py-[12px] 2xl:px-[30px]"
                />
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* --- Mobile Overlay Backdrop --- */}
      {/* This darkens the screen when menu is open. Clicking it closes the menu. */}
      <div
        className={`fixed inset-0 bg-black/50 z-[60] transition-opacity duration-300 ${
          menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setMenuOpen(false)}
      />

      {/* --- Mobile Sidebar (Right to Left) --- */}
      <div
        className={`fixed top-0 right-0 h-full w-[80%] max-w-[300px] bg-[#1c233a] z-[70] shadow-2xl transform transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full p-6">
          {/* Header inside Sidebar (Logo + Close Button) */}
          <div className="flex justify-between items-center mb-10">
            {/* Optional: Logo inside menu */}
            <div className="relative w-[40px] h-[40px]">
              <img
                src="/images/BottomLogo.webp"
                className="absolute w-full h-full animate-spin-slow"
                alt="logo"
              />
              <img
                src="/images/TopLogo.webp"
                className="absolute top-0 w-full h-full"
                alt="logo"
              />
            </div>

            <button
              onClick={() => setMenuOpen(false)}
              className="text-white focus:outline-none p-2"
              aria-label="Close menu"
            >
              <svg
                width="30"
                height="30"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Mobile Navigation Links */}
          <nav className="flex flex-col gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className="text-[20px] text-white font-[Sora] font-medium hover:text-[#7abf6b] border-b border-gray-700 pb-2"
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Mobile CTA Button */}
          <div className="mt-auto mb-8">
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              <Button
                text="Learn More"
                text_font_size="18"
                text_font_family="Sora"
                text_font_weight="700"
                text_line_height="24px"
                text_text_align="center"
                text_color="#ffffff"
                fill_background_color="#7abf6b"
                border_border_radius="30px"
                border_border="none"
                padding="12px 0"
                className="w-full"
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
